// removed by extract-text-webpack-plugin
module.exports = {"visually-hidden":"VisuallyHiddenSpan__visually-hidden___3LT7A"};